import { useState, useRef, useEffect, ReactNode } from 'react';
import useOutsideClick from '../../../hooks/useOusideClick';
import { IcoClose, IcoSearch } from '../../icon/icon';
import { validarCampo } from '../../validation/Validation';
import { Button } from '../../index';

const chargeDefault = { max: 0, text: 'Mais itens', action: () => null };

interface IRequired {
  erro: IError; // name do componente
  message: string; // mensagem de erro
  pattern: RegExp | string;
}

interface IError {
  name: string;
  message: string;
}

const defaultErr = {
  erro: '',
  message: '',
  pattern: /""/,
};

interface ICharge {
  max: number;
  text: string;
  action: () => void;
}

interface IResponse {
  name: string;
  value: any;
  type: 'select';
}

interface IFilter {
  clean: JSX.Element;
  filter: JSX.Element | string;
  action: (e: any) => void;
  title: string;
  text: string;
  cy: string;
}

export interface ISelectProps {
  options: Array<any>;
  action: (param: IResponse) => void;
  actionClose?: (resp: any, validate: any) => void;
  actionFilter?: (e: any, v: any) => void;
  selected?: string | string[] | any;
  label: string | JSX.Element;
  name: string;
  color?: string;
  closeOnSelect?: any;
  multiSelect?: boolean;
  disabled?: boolean;
  selectedItem?: boolean;
  textCustom?: string[];
  filter?: any;
  charge?: ICharge;
  optionLabel?: string;
  optionValue?: string;
  optionCustom?: (e: any) => void;
  labelCustom?: any;
  required?: IRequired;
  cy: string;
  style?: React.CSSProperties;
  hasInfiniteScroll?: boolean;
}

export const Select: React.FC<ISelectProps> = ({
  options,
  action,
  actionClose,
  actionFilter,
  selected,
  label,
  name,
  color = '',
  closeOnSelect = null,
  multiSelect = false,
  disabled = false,
  selectedItem = true,
  textCustom = ['Selecione', 'Selecionado', 'Selecionados', 'Marcar todos'],
  filter,
  charge = chargeDefault,
  optionLabel = 'name',
  optionValue = 'id',
  optionCustom,
  labelCustom,
  required,
  cy,
  hasInfiniteScroll = false,
  ...props
}) => {
  closeOnSelect = closeOnSelect === null ? !multiSelect : closeOnSelect;
  const [selectOpen, setSelectOpen] = useState(false);
  const [selectCoordinates, setSelectCoordinates] = useState({});
  const [selectState, setSelectState] = useState<Array<any>>([]);
  const [selectOptionsContainer, setSelectOptionsContainer] = useState();
  const openSelect = ({ elem, value }: any) => {
    if (elem) {
      const div = elem.target;
      const rect = div.getBoundingClientRect();
      const width = rect.width;
      setSelectOptionsContainer(rect);
      setSelectCoordinates({
        position: 'absolute',
        width,
        visibility: 'hidden',
      });
      setSelectOpen(value);
    }
  };
  useEffect(() => {
    if (selectOpen && selectOptionsContainer) {
      getSelectBoxPosition();
    }
  }, [selectOpen, selectState]);

  const getSelectBoxPosition = () => {
    const container = document.getElementById(`SelectBox${cy}`);
    if (selectOptionsContainer !== undefined) {
      const { top, height } = selectOptionsContainer;
      const windowHeight = window.innerHeight;
      if (Math.ceil(top + height) + 300 >= windowHeight) {
        setSelectCoordinates({
          ...selectCoordinates,
          top: -(Number(container?.clientHeight) + 2),
          visibility: 'visible',
        });
      } else {
        setSelectCoordinates({ ...selectCoordinates, visibility: 'visible' });
      }
    }
  };

  // const [displayedData, setDisplayedData] = useState(data.filter((el: any, i: number) => i < displayedArrayLength));
  const [counter, setCounter] = useState(1);
  const infiniteScrollLastElement = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '20px',
      threshold: 0.25,
    };

    const observer = new IntersectionObserver((entities) => {
      const target = entities[0];
      if (target.isIntersecting) {
        // setDisplayedData(data.filter((el: any, i: number) => i < (displayedArrayLength * counter)));
        setCounter(counter + 1);
      }
    }, options);
    if (infiniteScrollLastElement.current) {
      observer.observe(infiniteScrollLastElement.current);
    }
  });

  useEffect(() => {
    const newLength = 200 * counter;
    if (newLength >= options?.length) {
      setSelectState(options);
      return;
    }
    setSelectState(options.filter((_el: any, i: number) => i < newLength));
  }, [counter]);

  const ref = useRef(null);
  useOutsideClick(ref, (e: any) => {
    // openSelect({value: e})
    if (!e && selectOpen === true) {
      closeAction({ ...selected, ...selectState });
    }
  });

  useEffect(() => {
    if (!hasInfiniteScroll) {
      setSelectState(options || []);
    } else {
      const filtered = Array.isArray(options)
        ? options.filter((el: any, i: number) => i < 200)
        : [];
      setSelectState(options ? filtered : []);
    }
  }, [options, hasInfiniteScroll]);

  const veryfiMultiSelect = (e: any) => {
    const verify = selected.filter((elem: any) => {
      return elem[optionValue] === e[optionValue] ? elem : null;
    });

    const res = selected.filter((elem: any) => {
      return elem[optionValue] !== e[optionValue] ? elem : null;
    });

    if (selected.length === 0) {
      return [e];
    } else {
      if (verify.length === 0) {
        return selected.concat(e);
      } else {
        return res;
      }
    }
  };

  const selectAction = (e: any) => {
    const resp = multiSelect ? (e ? veryfiMultiSelect(e) : []) : e || {};
    action({ name, value: resp, type: 'select' });
  };

  const textButton = (e: any) => {
    if (!multiSelect) {
      const verifyObject = Object.keys(e);
      if (labelCustom) {
        return labelCustom(e);
      } else if (e[optionLabel]) {
        return e[optionLabel];
      } else {
        return verifyObject.length ? e : textCustom[0];
      }
    } else {
      if (e.length === 0) {
        return textCustom[0];
      } else if (e.length === 1) {
        return `${textCustom[1]} - ${e[0][optionLabel]} `;
      } else {
        return `${textCustom[2]} ( ${e.length} ) `;
      }
    }
  };

  const veryfiSelected = (e: any) => {
    if (!multiSelect) {
      return selected[optionValue] === e[optionValue];
    } else {
      if (selected.length === 0) {
        return false;
      } else {
        const verify = selected.filter((elem: any) => {
          return elem[optionValue] === e[optionValue] ? elem : null;
        });

        if (verify.length === 0) {
          return false;
        } else {
          return (verify[0] && verify[0][optionValue]) === e[optionValue];
        }
      }
    }
  };
  // const selectRef = useRef("Referencia");
  const selectAll = (e: any) => {
    action({ name, value: e ? options : [], type: 'select' });
  };

  const closeAction = (e: any) => {
    e = closeOnSelect && multiSelect ? selected : e;
    const resp = multiSelect ? e || [] : e || {};
    const v = require
      ? validarCampo({
          target: {
            name,
            value: resp,
            pattern: multiSelect ? 'multiselect' : 'select',
          },
        })
      : {};
    if (actionClose) {
      actionClose(resp, v);
    }
    setSelectOpen(false);
  };

  const require = required ? Object.keys(required) : undefined;

  return (
    <div
      {...props}
      className={`form-box form-select-box ${color} ${
        require &&
        required &&
        (required.erro[name as keyof IError] ? 'erro' : '')
      } `}
      data-cy={`SelectBox${name}`}
    >
      {label ? (
        <label
          className="label-input"
          htmlFor={`id-${name}`}
          data-cy={`SelectBoxLabel${name}`}
        >
          {require ? <span className="required-label">*</span> : ''} {label}
        </label>
      ) : null}
      <div>
        <Button
          className={`select-selected ${selectOpen ? 'open' : ''}`}
          onClick={(e: any) =>
            openSelect({ elem: e, value: !disabled ? !selectOpen : false })
          }
          cy="OpenSelect"
        >
          {textButton(selected)}
        </Button>
        {/* <Portal name="select"> */}
        {selectOpen && (
          <div
            ref={ref}
            className={`select-box select-${name} ${
              multiSelect ? 'multiselect' : ''
            }`}
            style={selectCoordinates}
            id={`SelectBox${cy}`}
          >
            {filter && actionFilter ? (
              <FilterSelect
                clean={filter.clean}
                action={(e: any) => [
                  setSelectState(FilterAction(options, e)),
                  actionFilter(options, e),
                ]}
                filter={filter.text}
                title={filter.title}
                text={filter.text}
                cy={cy}
              />
            ) : null}

            {multiSelect ? (
              <div
                data-cy={`MultiSelectContainer${cy}`}
                className={`select-all ${
                  selected.length > 0 && selected.length === options.length
                    ? 'selected'
                    : ''
                }`}
                onClick={() => [
                  selectAll(selected.length !== options.length ? true : ''),
                  closeOnSelect ? closeAction(selected) : null,
                ]}
              >
                <span
                  className="checkelement"
                  data-cy={`MultiSelectSpan${cy}`}
                ></span>
                {textCustom[3]}
              </div>
            ) : null}

            <div className="select-options">
              {!multiSelect && selectedItem ? (
                <div
                  onClick={(e) => [
                    selectAction(''),
                    closeOnSelect ? closeAction('') : null,
                  ]}
                  data-cy={`SelectedItemNotMultiSelect${textCustom[0]}`}
                >
                  {textCustom[0]}
                </div>
              ) : null}

              {selectState.map((e, i) => {
                return (
                  <div
                    className={veryfiSelected(selectState[i]) ? 'selected' : ''}
                    key={`${name}-${e[optionValue]}-${i}`}
                    onClick={(e) => [
                      selectAction(selectState[i]),
                      closeOnSelect ? closeAction(selectState[i]) : null,
                    ]}
                    data-cy={`CheckElementContainer[${i}]`}
                    ref={
                      hasInfiniteScroll && i === selectState.length - 1
                        ? infiniteScrollLastElement
                        : null
                    }
                  >
                    {multiSelect ? (
                      <span
                        className="checkelement"
                        data-cy={`CheckElementSpan[${i}]`}
                      ></span>
                    ) : null}
                    {optionCustom ? optionCustom(e) : e[optionLabel]}
                  </div>
                );
              })}
              {charge.max && !(selectState.length === charge.max) ? (
                <Button
                  className="btn primary normal block"
                  onClick={charge.action}
                  title={charge.text}
                  cy={`Select${charge.text}`}
                >
                  {charge.text}
                </Button>
              ) : null}
            </div>
          </div>
        )}
        {/* </Portal>  */}
      </div>

      {required?.erro?.[name as keyof IError] ? (
        <span className="campo-obrigatorio" data-cy="MandatorySelectFieldSpan">
          {required.message}
        </span>
      ) : null}
    </div>
  );
};

export const FilterAction = (d: any, e: any, n = 'name') => {
  return d.filter((i: any) => (e !== '' ? ([i[n]].includes(e) ? i : null) : i));
};

export const FilterSelect = ({
  action = (params: any) => null,
  title = 'Filtrar',
  cy,
  clean = <IcoClose cy={`Filter${cy}`} />,
  filter = <IcoSearch cy={`Filter${cy}`} />,
}: IFilter) => {
  const [filterState, setFilterState] = useState('');
  const cleanFilter = () => {
    setFilterState('');
  };
  const onActionFilter = (e: any) => {
    setFilterState(e);
    if (e.length >= 4) {
      action(e);
    } else if (e.length === 0) {
      action(e);
    }
  };
  return (
    <div className="select-filter">
      <div className="input-actions">
        <Button
          cy={`SelectFilter${cy}`}
          onClick={() => action(filterState)}
          title={title}
        >
          {filter}
        </Button>
      </div>
      <input
        type="text"
        name="filter-select"
        id={`id-filter-select`}
        value={filterState}
        onChange={(e: any) => onActionFilter(e.target.value)}
        placeholder={title}
        data-cy={`SelectInputFilter${cy}`}
      />
      <div className="input-actions">
        <Button
          className={filterState === '' ? 'hidden' : ''}
          onClick={() => [cleanFilter(), action('')]}
          cy={`CleanFilter${cy}`}
        >
          {clean}
        </Button>
      </div>
    </div>
  );
};

export const verifySelectValue = (e: any) => {
  if (Array.isArray(e.value)) {
    const val = e.value[0];
    const sel = e.list.filter(
      (v: any) => v[e.val ? e.val : 'name'] === val[e.val ? e.val : 'name']
    );
    return sel.length ? sel[0] : {};
  } else {
    const sel = e.list.filter(
      (v: any) => v[e.val ? e.val : 'name'] === e.value
    );
    return sel.length ? sel[0] : {};
  }
};
